import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import BarChart from "../../../statistic/BarChart";

const ProjectsTimeAverage = ({ selectedProjects }) => {
  const { projects } = useSelector((state) => state.projects);
  const initialValue = 0;
  const [realTimesSum, setRealTimesSum] = useState();
  const [estimatedTimesSum, setEstimatedTimesSum] = useState();
  const [timesData, setTimesData] = useState({});
  const [strategicProjects, setStrategicProjects] = useState([]);

  useEffect(() => {
    setStrategicProjects(
      (selectedProjects || projects || []).filter(
        (p) => p.isStrategic === true
      )
    );
  }, [selectedProjects, projects]);
  useEffect(() => {
    let nonOptionalTimesList = strategicProjects.filter(
      (p) => p.isTimeSpentOptional === false
    );
    let realTimesList = nonOptionalTimesList.map((p) => p.realTimeSpent);
    let estimatedTimesList = nonOptionalTimesList.map(
      (p) => p.estimatedTimeSpent
    );
    setRealTimesSum(
      realTimesList.reduce(
        (prevValue, currentValue) => prevValue + currentValue,
        initialValue
      )
    );
    setEstimatedTimesSum(
      estimatedTimesList.reduce(
        (prevValue, currentValue) => prevValue + currentValue,
        initialValue
      )
    );
  }, [strategicProjects]);

  useEffect(() => {
    setTimesData({
      labels: ["Temps"],
      datasets: [
        {
          label: "Estimé ",
          data: [estimatedTimesSum],
          backgroundColor: "rgba(73, 9, 170, 0.7)",
        },
        {
          label: "Réel",
          data: [realTimesSum],
          backgroundColor: "rgba(51, 148, 246, 0.7)",
        },
      ],
    });
  }, [estimatedTimesSum, realTimesSum]);

  return (
      <>
        <h2> Temps réel et estimé des projets(en heures)</h2>
        <BarChart chartData={timesData} />
      </>
  );
};

export default ProjectsTimeAverage;
